import { FC, ChangeEvent } from "react"
import { AddressInfo } from "../AddressInfo"
import { Facility } from "@/types/facility"

interface AddressProps {
   address: Facility["address"]
   setAddress: (address: Facility["address"]) => void
}

const Address: FC<AddressProps> = ({ address, setAddress }) => {
   const handleAddressFieldChange =
      (field: keyof Facility["address"]) =>
      (e: ChangeEvent<HTMLInputElement>) => {
         setAddress({
            ...address,
            [field]: e.target.value,
         })
      }

   const handleAddressChange = (e: ChangeEvent<HTMLInputElement>) =>
      handleAddressFieldChange(e.target.name as keyof Facility["address"])(e)

   const handleStateChange = (selectedState: string) => {
      setAddress({
         ...address,
         state: selectedState,
      })
   }

   const handleTimezoneChange = (timezone: Facility["address"]["timezone"]) => {
      setAddress({
         ...address,
         timezone,
      })
   }

   return (
      <AddressInfo
         isEditMode
         id=""
         address={address}
         onChange={handleAddressChange}
         onStateChange={handleStateChange}
         onTimezoneChange={handleTimezoneChange}
      />
   )
}

export default Address
